import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllDashboardService = ({
  page = "1",
  per_page = "15",
  enableQuery,
  showActiveOnly = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";
  const allDashboardService = useQuery({
    queryKey: [
      ...CACHE_KEYS.DASHBOARD,
      page,
      per_page,
      showActiveOnly,
      debouncedQuery,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.DASHBOARD,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          include: "role,cards,cards.card_type",
        },
      }),
    enabled: enableQuery,
  });
  return {
    service: { allDashboardService },
    states: { searchQuery, setSearchQuery },
  };
};
